import React from 'react';
import { Loader2, CheckCircle2 } from 'lucide-react';

interface SignInMfaFormProps {
  mfaCode: string;
  setMfaCode: (val: string) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

export const SignInMfaForm: React.FC<SignInMfaFormProps> = ({
  mfaCode,
  setMfaCode,
  isLoading,
  onSubmit,
  onCancel,
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-zinc-300 mb-1.5">
          6-Digit Verification Code
        </label>
        <input
          type="text"
          required
          autoFocus
          maxLength={6}
          value={mfaCode}
          onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, ''))}
          placeholder="123456"
          className="w-full bg-zinc-950/70 border border-zinc-800 rounded-xl py-3 px-4 text-center tracking-widest text-lg font-mono text-white placeholder-zinc-600 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition"
        />
      </div>

      <button
        type="submit"
        disabled={isLoading || mfaCode.length < 6}
        className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-semibold transition flex items-center justify-center gap-2 shadow-lg shadow-indigo-600/20 cursor-pointer disabled:opacity-50"
      >
        {isLoading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <>
            <CheckCircle2 className="w-4 h-4" />
            <span>Verify & Continue</span>
          </>
        )}
      </button>

      <button
        type="button"
        onClick={onCancel}
        className="w-full py-2 text-zinc-400 hover:text-zinc-200 text-xs transition"
      >
        Cancel and try again
      </button>
    </form>
  );
};
